/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import methods from './methods';
export default {
  data: function data() {
    return {
      customShowList: [],
      showModal: false,
      modalStatus: false,
      dataGridLoad: false,
      comModelProps: null,
      comModel: null,
      modelShowFields: null,
      dataGridColumns: [],
      gridData: [],
      queryFields: [],
      hiddenQueryFields: [],
      filterFields: {},
      pageNo: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 50, 100],
      labelWidth: 120,
      totalNum: 0,
      // 排序字段
      orderKey: [],
      // 排序类别（asc，desc）
      orderType: [],
      quickFilter: [],
      batch_select: [],
      multiColSetShow: false,
      column: [],
      slotColumn: [],
      // 操作
      funcAuth: [],
      showOper: true,
      hasRowOper: false,
      headOper: [],
      headOperBatch: [],
      rowOper: [],
      rowOperBatch: [],
      iframeUrl: '',
      iframeComponent: '',
      gridExportOptStatus: false,
      gridExportDataStatus: false,
      gridExportDataRequestParams: null,
      gridDataRequestParams: null,
      gridPrintOptStatus: false,
      gridPrintDataStatus: false,
      gridPrintDataRequestParams: null,
      modalId: '',
      modalTitle: '',
      modalWidth: 1000,
      modalHeight: 600,
      searchShow: false,
      pageSearch: true,
      showCheckbox: false,
      loading: true,
      dataGridId: '',
      clearCache: '',
      browsePerm: true,
      dataGridWidth: 0,
      dataGridHeight: -1,
      searchType: '01', // 查询控件 01:普通 02:简单,
      errorMsg: '',
      dbType: '',
      exportMaxCount: 0
    };
  },

  mixins: [methods],
  methods: {
    query_grid_data: function query_grid_data(pageNo) {
      var _this = this;

      this.loading = true;
      if (pageNo) {
        this.pageNo = pageNo;
      }
      var params = this.getGridRequestParams();
      console.log(params, 'params');
      this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/getQueryPageData', params: params }).then(function (resp) {
        if (resp.success) {
          // 回调
          if (_this.beforeRender) {
            _this.beforeRender(resp).then(function (data) {
              if (data.success) {
                _this.initRenderData(data.rows, data.total);
              }
            });
          } else {
            _this.initRenderData(resp.rows, resp.total);
          }

          //分组统计
          if (_this.comModel.groupStat && _this.comModel.groupStatField && resp.group && _this.quickFilter) {
            try {
              var groupStatFields = _this.comModel.groupStatField.split('|');
              groupStatFields.forEach(function (field) {
                _this.quickFilter[0].forEach(function (qf) {
                  if (qf.groupStatField) {
                    if (qf.groupStatField == field && resp.group[field]) {
                      qf.groupNum = resp.group[field][qf.groupMatchValue] || 0;
                    } else {
                      qf.groupNum = 0;
                    }
                  }
                });
              });
            } catch (e) {
              console.log('分组统计异常：', e);
            }
          }
        }
      });
    },
    getGridRequestParams: function getGridRequestParams() {
      var _this2 = this;

      var params = { modelId: this.comModel.mark, pageNo: this.pageNo, pageSize: this.pageSize, browsePerm: this.browsePerm };
      var searchCondis = [];
      var condis = this.build_query_condis();
      var filterCondis = this.build_filter_condis();
      if (filterCondis.length > 0) {
        searchCondis = searchCondis.concat(filterCondis);
      }
      if (condis.length > 0) {
        searchCondis = searchCondis.concat(condis);
      }
      if (searchCondis.length > 0) {
        params.condis = JSON.stringify(searchCondis);
      }
      var quickFilterSql = this.get_quick_filter();
      if (quickFilterSql && quickFilterSql !== '') {
        params.quickFilterSql = quickFilterSql;
      }

      var _orderKey = [];
      if (this.orderKey.length > 0) {
        this.orderKey.forEach(function (item) {
          var _key = _this2.chineseSort[item];
          if (_key) {
            _orderKey.push(_key);
          } else {
            _orderKey.push(item);
          }
        });
      }
      params.sortName = _orderKey.join(',');
      params.sortType = this.orderType.join(',');
      if (Object.keys(this.extendParams).length > 0) {
        params.extendParams = JSON.stringify(this.extendParams);
      } else if (Object.keys(this.params).length > 0) {
        params.extendParams = JSON.stringify(this.params);
      }
      return params;
    },
    initRenderData: function initRenderData(rowData, total) {
      this.gridData = rowData;
      this.totalNum = total;
      var disableFields = this.modelShowFields.filter(function (item) {
        return item.attachProps && JSON.parse(item.attachProps) && JSON.parse(item.attachProps)._disabled;
      });

      if (this.gridData && this.gridData.length > 0) {
        this.gridData.forEach(function (item) {
          disableFields.forEach(function (obj) {
            var props = JSON.parse(obj.attachProps);
            if (props._disabledValue == item[obj.name.toLowerCase()]) {
              item._disabled = true;
            }
          });
        });
      }
      this.batch_select = [];
      this.loading = false;
    },
    refreshGrid: function refreshGrid(pageNo) {
      this.query_grid_data(pageNo);
    },
    get_quick_filter: function get_quick_filter() {
      var filterSql = [];
      this.quickFilter.forEach(function (filters) {
        var orSql = [];
        filters.forEach(function (item) {
          if (item.isDefault === '1') {
            if (item.filterSql) {
              orSql.push(item.filterSql);
            }
          }
        });
        if (orSql.length > 0) {
          filterSql.push(orSql.join(' or '));
        }
      });
      return filterSql.join(' and ');
    },

    // condis参数
    build_query_condis: function build_query_condis() {
      var queryParams = [];
      var queryFields = this.queryFields.concat();
      var _that = this;
      if (this.hiddenQueryFields.length > 0) {
        var hiddenFields = [];
        var req = Object.assign({}, this.$route.query, this.params);
        var temValue = { user: this.$store.getters.sessionUser, req: req };
        this.hiddenQueryFields.forEach(function (field) {
          var item = Object.assign({}, field);
          var defaultValue = item.defaultValue ? item.defaultValue.trim() : '';
          var tem = _that.template(defaultValue, temValue);
          if (tem !== '') {
            item.searchValue = tem;
          }
          if (item.startDefault) {
            item.start = _that.template(item.startDefault.trim(), temValue);
          }
          if (item.endDefault) {
            item.end = _that.template(item.endDefault.trim(), temValue);
          }
          hiddenFields.push(item);
        });
        if (hiddenFields.length > 0) {
          queryFields.push(hiddenFields);
        }
      }
      queryFields.forEach(function (fields) {
        fields.forEach(function (item) {
          if (item.opName === 'between') {
            if (item.start) {
              var param = { name: item.name, op: '>=', value: item.start, valueType: item.valueType };
              queryParams.push(param);
            }
            if (item.end) {
              var endDefault = item.end;
              if (endDefault.length === 16 && item.valueType === 'datetime') {
                endDefault += ':59';
              } else if (endDefault.length === 14 && item.valueType === 'datetime') {
                endDefault += ':59:59';
              }
              var _param = { name: item.name, op: '<=', value: endDefault, valueType: item.valueType };
              queryParams.push(_param);
            }
          } else if (item.searchValue instanceof Array) {
            if (item.searchValue.length > 0) {
              var _param2 = { name: item.name, op: 'dicmultiple', value: item.searchValue.join(','), valueType: item.valueType };
              queryParams.push(_param2);
            }
          } else if (item.searchValue) {
            var _param3 = { name: item.name, op: item.opName, value: item.searchValue, valueType: item.valueType };
            if (item.isDicMultiple) {
              _param3.op = 'dicmultiple';
            }
            queryParams.push(_param3);
          }
        });
      });
      return queryParams;
    },
    build_filter_condis: function build_filter_condis() {
      var filterFields = {};
      Object.assign(filterFields, this.filterFields);
      var queryParams = [];
      for (var key in filterFields) {
        var valSize = filterFields[key].length;
        if (valSize > 0) {
          var op = '=';
          if (filterFields[key].length > 1) {
            op = 'dicmultiple';
          }
          var param = { name: key, op: op, value: filterFields[key].join(','), valueType: 'string' };
          queryParams.push(param);
        }
      }
      return queryParams;
    },
    on_batch_select: function on_batch_select(data) {
      // 批量选择
      this.batch_select = data;
    },
    isAuth: function isAuth(data) {
      if (data && data !== '') {
        return false;
      }
      return true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/data.js
// module id = 3
// module chunks = 0